/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { CreateTBankSBPPaymentMutationRequest, CreateTBankSBPPaymentMutationResponse, CreateTBankSBPPayment400, CreateTBankSBPPayment401, CreateTBankSBPPayment404, CreateTBankSBPPayment500 } from "../entities/CreateTBankSBPPayment";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { createTBankSBPPayment } from "../api/createTBankSBPPayment";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const createTBankSBPPaymentMutationKey = () => [{ url: '/api/v1/payments/sbp' }] as const

export type CreateTBankSBPPaymentMutationKey = ReturnType<typeof createTBankSBPPaymentMutationKey>

export function createTBankSBPPaymentMutationOptions<TContext = unknown>(config: Partial<RequestConfig<CreateTBankSBPPaymentMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = createTBankSBPPaymentMutationKey()
        return mutationOptions<CreateTBankSBPPaymentMutationResponse, ResponseErrorConfig<CreateTBankSBPPayment400 | CreateTBankSBPPayment401 | CreateTBankSBPPayment404 | CreateTBankSBPPayment500>, {data: CreateTBankSBPPaymentMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ data }) => {
            return createTBankSBPPayment(data, config)
          },
        })

}

/**
 * @description Создает новый платеж через платежную систему T-Bank.
 * **Требования:**
 * - Аутентификация по заголовкам `user-id` и `city-id`
 * - Минимальная сумма платежа: 120 RUB
 * - Максимальная сумма платежа: 9000 RUB
 * - Максимальная длина description: 140 символов
 * **Процесс:**
 * 1. Валидация входных данных
 * 2. Создание записи в БД
 * 3. Отправка запроса в T-Bank API
 * 4. Возврат URL для оплаты
 * @summary Инициализация платежа через T-Bank для СБП
 * {@link /api/v1/payments/sbp}
 */
export function useCreateTBankSBPPayment<TContext>(options: 
{
  mutation?: UseMutationOptions<CreateTBankSBPPaymentMutationResponse, ResponseErrorConfig<CreateTBankSBPPayment400 | CreateTBankSBPPayment401 | CreateTBankSBPPayment404 | CreateTBankSBPPayment500>, {data: CreateTBankSBPPaymentMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<CreateTBankSBPPaymentMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? createTBankSBPPaymentMutationKey()

          const baseOptions = createTBankSBPPaymentMutationOptions(config) as UseMutationOptions<CreateTBankSBPPaymentMutationResponse, ResponseErrorConfig<CreateTBankSBPPayment400 | CreateTBankSBPPayment401 | CreateTBankSBPPayment404 | CreateTBankSBPPayment500>, {data: CreateTBankSBPPaymentMutationRequest}, TContext>
          

          return useMutation<CreateTBankSBPPaymentMutationResponse, ResponseErrorConfig<CreateTBankSBPPayment400 | CreateTBankSBPPayment401 | CreateTBankSBPPayment404 | CreateTBankSBPPayment500>, {data: CreateTBankSBPPaymentMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<CreateTBankSBPPaymentMutationResponse, ResponseErrorConfig<CreateTBankSBPPayment400 | CreateTBankSBPPayment401 | CreateTBankSBPPayment404 | CreateTBankSBPPayment500>, {data: CreateTBankSBPPaymentMutationRequest}, TContext>
      
}